import {getLocalizedStrings} from '@/services/localization/localizationService';
import stylesUtils from '@/utils/stylesUtils';
import {twx} from '@/utils/tailwindUtils';

const HealthWarningPrimary = ({descriptionKey, fontFamily, fontSize}) => {
    const localizedStrings = getLocalizedStrings();
    const description = localizedStrings[descriptionKey];

    if (!description) return;

    const styles = stylesUtils.getFontSizeStyles(fontSize);
    const fontFamilyClassName = stylesUtils.getFontFamilyClassName(fontFamily);

    return (
        <div className='w-full px-4 pb-8 lg:px-16 lg:pb-12'>
            <div
                className={twx(
                    'leading-142 flex h-[15vh] items-center justify-center border-2 border-black bg-romance px-4 py-6 text-center text-14 font-bold tracking-02 text-primary',
                    fontFamilyClassName
                )}
            >
                <p style={styles} dangerouslySetInnerHTML={{__html: description}} />
            </div>
        </div>
    );
};

export default HealthWarningPrimary;
